export const footer = {
    copyright: {
        label: "全著作権所有！",
    },
};
